<template>
  <ScrollableContainer v-if="state.recentlyViewed?.length" :is-component-section="true">
    <ProductCard
      v-for="(product, i) in state.recentlyViewed"
      :key="product?.product_offerings?.bc_primary_product?.product?.id"
      :product="product"
      :is-dynamic-section="true"
      :render-mode="'plp'"
      :show_add_to_cart="true"
      :index="i"
    />
  </ScrollableContainer>
  <div v-else class="h3 mgn-top-3 txt-center">No Recently Viewed Items</div>
</template>

<script setup lang="ts">
import { getLocalStorageItem, recentlyViewedKey } from '~/util/localStorage';

const state = reactive({
  recentlyViewed: null as any,
});

onMounted(() => {
  state.recentlyViewed = getLocalStorageItem(recentlyViewedKey);
});
</script>
